import { MediaInfoResponse } from '@key-telematics/fleet-api-client';


export const MEDIA_STATES = ['pending', 'uploading', 'available', 'downloading', 'processing', 'ready', 'failed', 'queued', 'canceled', 'deleted'];
export interface NamedMediaResponse extends MediaInfoResponse {
    name: string;
}
